<template>
    <div class="n-pb-4">
        <div class="c-banner c-banner-small n-col-1 n-border-box n-overflow-hidden"
             style="height: 200px;">
            <NImage class="c-banner-image n-col-1 n-h-1"
                    type="cover"
                    :src="require('@/assets/image/banner.jpg')">
            </NImage>

            <div class="c-banner-text n-col-1 c-max-width-2">
            </div>
        </div>

        <NewsDetailContent :id="$route.query.id"></NewsDetailContent>
    </div>
</template>
<script>
    import { mapMutations, mapState } from "vuex";

    import {
        MenuUnfoldOutlined,
    } from "@ant-design/icons-vue";
    import NImage from "@/components/nui/NImage/NImage.vue";
    import Breadcrumb from "@/components/Breadcrumb.vue";
    import nui from "@/assets/script";
    import NewsDetailContent from '@/components/NewsDetailContent.vue'

    export default {
        name: "NewsDetail",
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
            });
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),
        }),
        components: {
            MenuUnfoldOutlined,
            NImage,
            NewsDetailContent,
            Breadcrumb
        },
        ...nui.extendVue.extendLife,
    };
</script>
<style lang="scss">
    .pdf-dialog {
        max-width: 100% !important;

        .ant-modal-header {
            background: rgba(56, 56, 61, 1);
            padding: 10px;
            height: 40px;
            border-bottom: 0;
        }

        .ant-modal-title {
            color: $font-color-1;
        }

        .ant-modal-close-x {
            color: $font-color-1;
            width: 40px;
            height: 40px;
            line-height: 40px;
        }

        .ant-modal-content {
            height: 100%;
        }

        .ant-modal-body {
            height: calc(100% - 40px);
        }
    }
</style>
